import { useMarkConversationReadMutation } from '@shared/generated/graphql';
import { useEffect, useState } from 'react';

function useIsTabVisible(): boolean {
  const [isVisible, setIsVisible] = useState(
    () => typeof document === 'undefined' || !document.hidden
  );
  useEffect(() => {
    const handleChange = () => setIsVisible(!document.hidden);
    document.addEventListener('visibilitychange', handleChange);
    return () => document.removeEventListener('visibilitychange', handleChange);
  }, []);
  return isVisible;
}

export function useMarkConversationRead(
  conversationId: string,
  latestMessageId: string | undefined
): void {
  const isTabVisible = useIsTabVisible();
  const [markConversationRead] = useMarkConversationReadMutation();

  useEffect(() => {
    if (!latestMessageId || !isTabVisible) return;
    markConversationRead({
      variables: {
        input: { conversationId, throughMessageId: latestMessageId },
      },
      update: (cache) => {
        cache.modify({
          id: cache.identify({
            __typename: 'Conversation',
            id: conversationId,
          }),
          fields: { hasUnreadMessages: () => false },
        });
      },
    }).catch(console.error);
  }, [conversationId, isTabVisible, latestMessageId, markConversationRead]);
}
